import Select from "react-select";
import Drawer from 'react-modern-drawer';
import { FormGroup, Input, Label } from "reactstrap";
import SelectCustomStyles from "../../../../../utils/styles/reactSelect";
import { useEffect, useState } from "react";
import countries from "../../../../../data/countries";
import { toast } from "react-toastify";
import { post } from "../../../../../utils/helpers/api";
import DefaultButton from "../../../../../components/Buttons/Default";
import { useTranslation } from "react-i18next";

function AddContactDrawer({ isOpen, toggle, isNew, supplierData, editData, onSaved, onLocalSave }) {
  const { t } = useTranslation();
  const [saveLoading, setSaveLoading] = useState(false);
  const [contactData, setContactData] = useState({
    label: '',
    responsible_name: '',
    phone_number: '',
    email: '',
    country: ''
  });

  useEffect(() => {
    setContactData({
      label: editData?.label || '',
      responsible_name: editData?.responsible_name || '',
      phone_number: editData?.phone_number || '',
      email: editData?.email || '',
      country: editData?.country || ''
    });
  }, [editData, isOpen]);

  const saveContact = async () => {
    if (isNew) {
      onLocalSave?.({ ...contactData, _tempId: editData?._tempId });
      toggle();
      return;
    }

    setSaveLoading(true);
    const url = editData
      ? '/purchases/suppliers/contacts/update/' + editData.id
      : '/purchases/suppliers/contacts/store/' + supplierData.id;
    const data = await post(url, { ...contactData });

    if (data.success) {
      toggle();
      onSaved?.();
    } else {
      toast.error(data.message || t('common.somethingWentWrong'));
    }
    setSaveLoading(false);
  };

  return (
    <Drawer
      open={isOpen}
      onClose={toggle}
      direction="right"
      size={'50%'}
      enableOverlay={true}
      lockScroll={true}
      zIndex={9000}
      duration={200}
    >
      <div className="p-3">
        <h4 className="fw-bold">
          {editData ? t('common.edit') : t('purchases.addContact')}
        </h4>

        <FormGroup>
          <Label>{t("inventory.label")}</Label>
          <Input
            value={contactData.label}
            onChange={(e) => setContactData({ ...contactData, label: e.target.value })}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t("common.name")}</Label>
          <Input
            value={contactData.responsible_name}
            onChange={(e) => setContactData({ ...contactData, responsible_name: e.target.value })}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t("common.phone")}</Label>
          <Input
            value={contactData.phone_number}
            onChange={(e) => setContactData({ ...contactData, phone_number: e.target.value })}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t("common.email")}</Label>
          <Input
            value={contactData.email}
            onChange={(e) => setContactData({ ...contactData, email: e.target.value })}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t("common.country")}</Label>
          <Select
            value={countries.map(c => ({ value: c.slug, label: c.name })).find(o => o.value === contactData.country) || null}
            onChange={(selected) => setContactData({ ...contactData, country: selected ? selected.value : '' })}
            options={countries.map((country) => ({ value: country.slug, label: country.name }))}
            styles={SelectCustomStyles}
          />
        </FormGroup>

        <DefaultButton
          color="primary"
          size="sm"
          onClick={saveContact}
          disabled={saveLoading}
          loading={saveLoading}
        >
          {t("common.save")}
        </DefaultButton>
      </div>
    </Drawer>
  );
}

export default AddContactDrawer;
